
import template from '../../../templates/checkout-flow/confirmation.directive.tpl.html';

import app from '../../App';

export function confirmationDirective () {
    
    'ngInject';

    return {
        restrict: 'E',
        scope: {
            data: '=',
            laststep:'=',
            taxrate: '=',
            selectedshippingrate: '='
        },
        templateUrl: template,
        link: ( scope, element, attrs ) => {
            scope.gotoLoginPage= () => {
                location.href = 'https://login.enplug.com';
            };
        }
    };
};

app.directive( 'confirmationDirective', confirmationDirective );



// WEBPACK FOOTER //
// ./src/js/directives/checkout-flow/confirmation-directive.js